/**
 * Created by mzietek on 2017-03-06.
 */

(function(angular) {
    angular
        .module('repairforms.service.module')
        .service('DateService', DateService);

    DateService.$inject = ['RepairformsRequestService', '$q'];

    function DateService(RepairformsRequestService, $q) {
        return {
            getFirstValidDate     : getFirstValidDate,
            getNextWorkingDay     : getNextWorkingDay,
            isValidDate           : isValidDate,
            dsplDateToDateObj     : dsplDateToDateObj,
            isHoliday             : isHoliday,
            getHolidays           : getHolidays,
            isAcceptablePickUpDay : isAcceptablePickUpDay,
            isWorkingDay          : isWorkingDay,
            dateObjToDsplDate     : dateObjToDsplDate,
            dsplDateToRequestDate : dsplDateToRequestDate
        };

        function dsplDateToDateObj(dateStr) {
            if(!dateStr) {
                return null;
            }

            var dateParts = dateStr.split('.');
            if(dateParts.length === 3) {
                var formattedDate = dateParts[1] + '/' + dateParts[0] + '/' + dateParts[2];
                return new Date(formattedDate);
            }

            return 'Invalid Date';
        }
        function dsplDateToRequestDate(displayDate) {
            if (displayDate && isValidDate(dsplDateToDateObj(displayDate))) {
                return displayDate.split('.')[2] + '-' + displayDate.split('.')[1] + '-' + displayDate.split('.')[0];
            }
            return null;
        }
        function dateObjToDsplDate(date) {
            var day = '' + date.getDate();
            if(day.length === 1) {
                day = '0' + day;
            }

            var month = '' + (date.getMonth() + 1);
            if(month.length === 1) {
                month = '0' + month;
            }

            var year = date.getFullYear();

            return day + '.' + month + '.' + year;
        }

        function getFirstValidDate(hourLimit, minutes) {
            var startDate = new Date();
            var limitDailyTimeInInMinutes = hourLimit * 60 + (minutes? minutes : 0);

            var selectedDailyTimeInMinutes = startDate.getHours() * 60 + startDate.getMinutes();

            var firstValidDate = getNextWorkingDay(startDate);
            if (isSaturday(startDate) || isSunday(startDate) || selectedDailyTimeInMinutes >= limitDailyTimeInInMinutes) {
                firstValidDate = getNextWorkingDay(firstValidDate);
            }

            firstValidDate.setHours(0);
            firstValidDate.setMinutes(0);
            firstValidDate.setSeconds(0);
            firstValidDate.setMilliseconds(0);
            return firstValidDate;
        }
        function getNextWorkingDay(startDate) {
            var iterableDate = new Date(startDate);
            do {
                iterableDate.setDate(iterableDate.getDate() + 1);
            } while (!isWorkingDay(iterableDate));

            return iterableDate;
        }
        function isWorkingDay(date) {
            return !isSaturday(date) && !isSunday(date);
        }
        function isSaturday(date) {
            return date.getDay() == 6;
        }
        function isSunday(date) {
            return date.getDay() == 0;
        }
        function isValidDate(date) {
            return date != 'Invalid Date';
        }
        function isHoliday(date, holidayList) {
            return isValidDate(date) && holidayList && holidayList.indexOf(dateObjToDsplDate(date)) > -1;
        }
        function getHolidays() {
            var deferred = $q.defer();

            RepairformsRequestService.getHolidaysDates().then(
                function successCallback(response) {
                    deferred.resolve(response.data);
                },
                function errorCallback(response) {
                    deferred.resolve(null);
                }
            );

            return deferred.promise;
        }
        function isAcceptablePickUpDay(date, pickUpHourLimit) {
            if(!isValidDate(date) || isNaN(pickUpHourLimit)) {
                return false;
            }
            var firstValidDate = getFirstValidDate(pickUpHourLimit);
            return date >= firstValidDate;
        }
    }
})(angular);